import _DTO from "./_DTO";

export default class RangeInfoDTO extends _DTO {

  constructor(rangeInfo) {
    super();
    this.rangeId = rangeInfo.rangeId;
    this.rangeName = rangeInfo.rangeName;
  }

}
